import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function EditServerModal({ server, closeModal, onUpdate }) {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('general');

    const [formData, setFormData] = useState({
        companyName: server.companyName || '',
        companyEmail: server.companyEmail || '',
        phoneNumber: server.phoneNumber || '',
        website: server.website || '',
        companyAddress: server.companyAddress || '',
        registeredOffice: server.registeredOffice || '',
        companyLogo: server.companyLogo || '',
        bio: server.bio || [], 
        contractStartDate: server.contractStartDate || '',
        contractEndDate: server.contractEndDate || '',
        
        openingHours: server.openingHours || '',
        weekStartDay: server.weekStartDay || 'Monday',
        personalisation: server.personalisation || '', 

        companyNumber: server.companyNumber || '',
        vatNumber: server.vatNumber || '',
        bankName: server.bankName || '',
        accountName: server.accountName || '',
        accountNumber: server.accountNumber || '',
        accountSortcode: server.accountSortcode || '',

        cqcLocationID: server.cqcLocationID || '',
        cqcProviderID: server.cqcProviderID || '',
        typesOfServices: server.typesOfServices ? server.typesOfServices.join('\n') : '', 

        is_architecture: server.is_architecture ?? true,
        is_elearning: server.is_elearning ?? false,
        is_sjf: server.is_sjf ?? false,
        
        hrServiceActive: server.hrServiceActive ?? false,
        slServiceActive: server.slServiceActive ?? false,
        slServiceCost: server.slServiceCost || 0,
        superAdminPermissions: server.superAdminPermissions ?? true,
        isLite: server.isLite ?? true,
        maxUsers: server.maxUsers || ''
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        let finalValue = type === 'checkbox' ? checked : value;
        if (name === 'isLite') {
            finalValue = value === 'true';
        }

        setFormData(prev => ({
            ...prev,
            [name]: finalValue
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const docRef = doc(db, 'servers', server.id); 
            
            const payload = {
                ...formData,
                typesOfServices: formData.typesOfServices.split('\n').filter(line => line.trim() !== ''),
                slServiceCost: Number(formData.slServiceCost),
                maxUsers: Number(formData.maxUsers) || 0,
                isLite: Boolean(formData.isLite)
            };

            await updateDoc(docRef, payload);
            alert("Server details updated successfully!");
            onUpdate(); 
            closeModal();
        } catch (error) {
            console.error("Error updating server:", error);
            alert("Failed to update: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const modalStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const contentStyle = { backgroundColor: 'white', width: '90%', maxWidth: '800px', height: '85%', borderRadius: '12px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' };
    const tabBtnStyle = (tab) => ({ padding: '15px 20px', border: 'none', background: activeTab === tab ? '#f0f4f8' : 'transparent', borderBottom: activeTab === tab ? '3px solid #3182ce' : '3px solid transparent', cursor: 'pointer', fontWeight: 'bold', color: activeTab === tab ? '#2c3e50' : '#718096' });
    const sectionStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '15px' };
    const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px', color: '#4a5568' };
    const inputStyle = { width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e0', marginBottom: '10px' };

    return (
        <div style={modalStyle}>
            <div style={contentStyle}>
                <div style={{ padding: '20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 style={{ margin: '0' }}>Edit Server: {server.companyName}</h2>
                    <button onClick={closeModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>×</button>
                </div>

                <div style={{ display: 'flex', borderBottom: '1px solid #eee' }}>
                    {['general', 'financial', 'cqc', 'settings'].map(t => (
                        <button key={t} onClick={() => setActiveTab(t)} style={tabBtnStyle(t)}>
                            {t.charAt(0).toUpperCase() + t.slice(1)}
                        </button>
                    ))}
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: '30px' }}>
                    <form id="editServerForm" onSubmit={handleSubmit}>
                        
                        {activeTab === 'general' && (
                            <>
                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>Company Name</label><input name="companyName" value={formData.companyName} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>Company Email</label><input name="companyEmail" value={formData.companyEmail} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>Phone Number</label><input name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>Website</label><input name="website" value={formData.website} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>Contract Start Date</label><input type="date" name="contractStartDate" value={formData.contractStartDate} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>Contract End Date</label><input type="date" name="contractEndDate" value={formData.contractEndDate} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <label style={labelStyle}>Company Address</label>
                                <input name="companyAddress" value={formData.companyAddress} onChange={handleChange} style={inputStyle} />
                                <label style={labelStyle}>Registered Office</label>
                                <input name="registeredOffice" value={formData.registeredOffice} onChange={handleChange} style={inputStyle} />
                                <label style={labelStyle}>Logo URL</label>
                                <input name="companyLogo" value={formData.companyLogo} onChange={handleChange} style={inputStyle} />
                            </>
                        )}

                        {activeTab === 'financial' && (
                            <>
                                <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ margin: '0 0 15px 0', color: '#3182ce' }}>License & Tier Limits</h4>
                                    <div style={sectionStyle}>
                                        <div>
                                            <label style={labelStyle}>Billing Tier</label>
                                            <select name="isLite" value={formData.isLite.toString()} onChange={handleChange} style={inputStyle}>
                                                <option value="true">Freemium (Lite)</option>
                                                <option value="false">Premium</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={labelStyle}>Max Total Staff (Admins + Employees)</label>
                                            <input type="number" name="maxUsers" value={formData.maxUsers} onChange={handleChange} placeholder="e.g. 25" style={inputStyle} />
                                        </div>
                                    </div>
                                </div>

                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>Company Number</label><input name="companyNumber" value={formData.companyNumber} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>VAT Number</label><input name="vatNumber" value={formData.vatNumber} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <h4 style={{ margin: '10px 0', color: '#3182ce' }}>Bank Details</h4>
                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>Bank Name</label><input name="bankName" value={formData.bankName} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>Account Name</label><input name="accountName" value={formData.accountName} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>Account Number</label><input name="accountNumber" value={formData.accountNumber} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>Sort Code</label><input name="accountSortcode" value={formData.accountSortcode} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                            </>
                        )}

                        {activeTab === 'cqc' && (
                            <>
                                <div style={sectionStyle}>
                                    <div><label style={labelStyle}>CQC Location ID</label><input name="cqcLocationID" value={formData.cqcLocationID} onChange={handleChange} style={inputStyle} /></div>
                                    <div><label style={labelStyle}>CQC Provider ID</label><input name="cqcProviderID" value={formData.cqcProviderID} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <label style={labelStyle}>Types of Services (One per line)</label>
                                <textarea 
                                    name="typesOfServices" 
                                    value={formData.typesOfServices} 
                                    onChange={handleChange} 
                                    style={{ ...inputStyle, height: '100px', fontFamily: 'monospace' }} 
                                    placeholder="Domiciliary care..."
                                />
                                <div style={{ marginTop: '10px', padding: '15px', background: '#f7fafc', borderRadius: '8px' }}>
                                    <label style={labelStyle}>Active Services (Billing)</label>
                                    <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                                        <label><input type="checkbox" name="hrServiceActive" checked={formData.hrServiceActive} onChange={handleChange} /> HR Service</label>
                                        <label><input type="checkbox" name="slServiceActive" checked={formData.slServiceActive} onChange={handleChange} /> SL Service</label>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <label style={labelStyle}>SL Service Cost</label>
                                        <input type="number" name="slServiceCost" value={formData.slServiceCost} onChange={handleChange} style={inputStyle} />
                                    </div>
                                </div>
                            </>
                        )}

                        {activeTab === 'settings' && (
                            <>
                                <div style={sectionStyle}>
                                    <div>
                                        <label style={labelStyle}>Week Starts On</label>
                                        <select name="weekStartDay" value={formData.weekStartDay} onChange={handleChange} style={inputStyle}>
                                            <option value="Monday">Monday</option>
                                            <option value="Sunday">Sunday</option>
                                        </select>
                                    </div>
                                    <div><label style={labelStyle}>Personalisation Label</label><input name="personalisation" value={formData.personalisation} onChange={handleChange} style={inputStyle} /></div>
                                </div>
                                <label style={labelStyle}>Opening Hours Text</label>
                                <input name="openingHours" value={formData.openingHours} onChange={handleChange} style={inputStyle} />
                                
                                <h4 style={{ margin: '15px 0 10px', color: '#3182ce' }}>Active Modules</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                                    <label style={{ padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px' }}><input type="checkbox" name="is_architecture" checked={formData.is_architecture} onChange={handleChange} /> Architecture</label>
                                    <label style={{ padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px' }}><input type="checkbox" name="is_elearning" checked={formData.is_elearning} onChange={handleChange} /> E-Learning</label>
                                    <label style={{ padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px' }}><input type="checkbox" name="is_sjf" checked={formData.is_sjf} onChange={handleChange} /> SJF</label>
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={{ padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', display: 'block' }}><input type="checkbox" name="superAdminPermissions" checked={formData.superAdminPermissions} onChange={handleChange} /> Super Admin Permissions</label>
                                </div>
                            </>
                        )}
                    </form>
                </div>

                <div style={{ padding: '20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '10px', background: '#f8f9fa' }}>
                    <button onClick={closeModal} style={{ padding: '10px 20px', border: '1px solid #ccc', borderRadius: '6px', background: 'white', cursor: 'pointer' }}>Cancel</button>
                    <button type="submit" form="editServerForm" disabled={loading} style={{ padding: '10px 20px', border: 'none', borderRadius: '6px', background: '#3182ce', color: 'white', cursor: loading ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}>
                        {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}